import React, { Component } from 'react';
import parse from 'html-react-parser';
import IconNewWindow from '../atoms/IconNewWindow';

class LocationCollectionSite extends Component {
  render() {
    if ( this.props.locationData.rwm_link && this.props.locationData.collected_location ) {
      return (
        <>
          <p>Soil collected from</p>
          <p>
            <a className="hasIcon hasSmallIcon hasIconRight" href={this.props.locationData.rwm_link} target="_blank" rel="noopener noreferrer">
              {parse(this.props.locationData.collected_location)}
              <IconNewWindow/>
            </a>
          </p>
        </>
      )
    } else if ( this.props.locationData.collected_location ) {
      return (
        <>
          <p>Soil collected from</p>
          <p>{parse(this.props.locationData.collected_location)}</p>
        </>
      )
    } else {
      return (
        <>
          <p>Soil collected from</p>
          <p>To be collected</p>
        </>
      )
    }
  }
}

export default LocationCollectionSite;